// @ts-strict-ignore
import clsx from 'clsx'
import Image from 'next/image'
import Link from 'next/link'
import { FC } from 'react'

import { BASE_URL } from '@/shared/lib/const/env'

import { AcsPreviewProps } from '../../types'

import cl from './style.module.scss'

export const AcsPreview: FC<AcsPreviewProps> = ({ items, className = '' }) => {
	const capitalizedFirstWord = (NAME: string) => {
		const words = NAME.split(' ')
		if (words[0] === 'Аксессуары') {
			words.shift()
			words[0] = words[0]
				.split('')
				.map((item, index) => (index === 0 ? item.toUpperCase() : item))
				.join('')
		}
		return words.join(' ')
	}
	return (
		<ul className={clsx(cl.list, className)}>
			{items?.map(({ NAME, PICTURE, LINK }) => {
				return (
					<Link prefetch={false} href={LINK} key={LINK} className={cl.link}>
						<li className={cl.item}>
							<div className={cl.wrapper}>
								<Image
									src={BASE_URL + PICTURE}
									width={188}
									height={188}
									className={cl.img}
									alt={`Иконка секции ${NAME}`}
								/>
							</div>
							<p className={cl.title}>{capitalizedFirstWord(NAME)}</p>
						</li>
					</Link>
				)
			})}
		</ul>
	)
}
